import {DialogPanel} from '@headlessui/react'

import {twMerge} from '@sdox/utils'

import type {SlideoutVariants} from './types'
import type {PropsWithChildren} from 'react'

export interface SlideoutContainerProps extends PropsWithChildren {
  className?: string
  variant?: SlideoutVariants
}

export const SlideoutContainer = ({
  variant = 'content',
  className,
  children,
}: SlideoutContainerProps) => (
  <DialogPanel
    className={twMerge(
      'relative flex flex-col bg-surface-secondary @container',
      variant === 'content' && 'size-full slideout:min-w-[820px] slideout:max-w-section',
      (variant === 'crud-cufe' || variant === 'crud-eufe') && [
        'size-full max-w-screen-tablet',
        'tablet:max-h-[720px]',
        'md:max-h-full',
        'xl:max-h-[720px]',
      ],
      className,
    )}
  >
    {children}
  </DialogPanel>
)